
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/tags';

interface IState {
  resourceType: string;
  tags: string[];
}

export default defineComponent({
  data() {
    return {
      resourceType: 'Theme',
      tags: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          resourceType: this.resourceType,
        },
        (res) => {
          this.tags = res.tags;
        },
      );
    },

    apiAdd(tag: string) {
      api.add(
        {
          resourceType: this.resourceType,
          tag,
        },
        (res) => {
          if (!res) return;
          utils.success('标签添加成功！');
          this.apiGet();
        },
      );
    },

    apiDelete(tag: string) {
      api.delete(
        {
          resourceType: this.resourceType,
          tag,
        },
        (res) => {
          if (!res) return;
          this.apiGet();
        },
      );
    },

    btnNavClick() {
      this.apiGet();
    },

    btnAddClick() {
      utils.prompt(
        {
          title: '提示',
          message: '请输入标签',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
        (value) => {
          this.apiAdd(value);
        },
      );
    },

    btnDeleteClick(tag: string) {
      utils.alertDelete(
        {
          title: '删除标签',
        },
        () => {
          this.apiDelete(tag);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
